import { FC } from 'react';
import { LoadingDot, Root } from './styled';

type Props = {
  size?: 'small' | 'medium' | 'large';
  center?: boolean;
  padding?: boolean;
};

const Loader: FC<Props> = ({
  size = 'medium',
  center = false,
  padding = false,
}) => {
  return (
    <Root size={size} $center={center} $padding={padding} data-testid="loader">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <LoadingDot key={i} $index={i} size={size} />
      ))}
    </Root>
  );
};

export default Loader;
